import React from "react";
import id from "@irati/utils/id";
import "./style.css";
var Loader = function (props) { return React.createElement("div", { id: id("loader", props), className: "loader" }); };
export default Loader;
